import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { Password } from "primereact/password";
import { InputMask } from "primereact/inputmask";
import { toast } from "react-toastify";
import axios from "axios";
import appUrl from "../../../config/appUrl";
const AddEditUser = ({ onHide, getUserList, addEditUser, userdataId }) => {
  const [boothList, setBoothList] = useState("");
  const [userRole, setUserRole] = useState("");
  const [loading, setLoading] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteBooths, setSiteBooths] = useState([]);
  const [userType, setUserType] = useState([]);
  const [siteValue, setSitevalue] = useState(null);
  console.log("Final Site List:", siteList);
  const [siteId, setSiteId] = useState("");
  const validationSchema = Yup.object().shape({
    firstName: Yup.mixed().required("This field is required."),
    lastName: Yup.mixed().required("This field is required."),
    cnic: Yup.mixed().required("This field is required."),
    phone: Yup.mixed().required("This field is r  equired."),
    email: Yup.mixed().required("This field is required."),
    password: addEditUser
      ? ""
      : Yup.string()
          .required("This field is required.")
          .matches(
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            "Password must have at least:1 uppercase letter,1 lowercase letter,1 number and 1 special character "
          ),

    // gateRole:
    //   userRole === "admin"
    //     ? Yup.mixed().notRequired("This field is required.")
    //     : Yup.mixed().required("This field is required."),
    status: Yup.mixed().when("editMode", {
      is: true,
      then: Yup.mixed().required("This field is required."),
      otherwise: Yup.mixed(),
    }),
    // boothId:
    //   userRole === "admin"
    //     ? Yup.mixed().notRequired("This field is required.")
    //     : Yup.mixed().required("This field is required."),
    role: Yup.mixed().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      firstName: "",
      lastName: "",
      cnic: "",
      phone: "",
      site: "",
      email: "",
      password: "",
      editMode: addEditUser,
      status: "",
      role: "",
      ...(userRole !== "admin" && { gateRole: "" }),
      ...(userRole !== "admin" && { boothId: "" }),
    },

    onSubmit: async (data) => {
      if (addEditUser) {
        // handle editing user
        try {
          data["userId"] = userdataId;
          const response = await fetch(`${appUrl.BASE_URL}user`, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });

          if (response?.status === 201 || response?.status === 200) {
            toast.success("success");
            await getUserList();
          }
          onHide();
        } catch (error) {
          console.error(error);
        }
      } else {
        try {
          const response = await fetch(
            `${appUrl.BASE_URL}user/register`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );

          if (response?.status === 201 || response?.status === 200) {
            toast.success("success");
            await getUserList();
          }
          onHide();
        } catch (error) {
          console.error(error);
        }
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  useEffect(() => {
    if (userRole === "admin") {
      const { gateRole, boothId, ...initialValues } = formik.values;
      formik.setValues(initialValues);
    }
  }, [userRole]);

  const getUserByID = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}user/id?userId=${userdataId}`
      );
      const keyData = await response.json();
      Object.keys(keyData).forEach((key) => {
        if (formik?.initialValues?.hasOwnProperty(key)) {
          if (key === "role" && keyData.role) {
            formik.setFieldValue("role", keyData.role.role);
          } else if (key === "boothId" && keyData.boothId) {
            formik.setFieldValue("boothId", keyData.boothId._id);
          } else {
            formik.setFieldValue(key, keyData[key]);
          }
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getBoothId = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${appUrl.BASE_URL}booth/all`);
      const data = await response.json();
      setBoothList(data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getBoothBySite = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}booth/getBySite?siteId=${userSite}`
      );
      const data = await response.json();
      setSiteBooths(data?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getSiteList = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();
      setSiteList(data.data); // Assuming your API response is an object with a 'data' property
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  console.log("boothList==", boothList);
  useEffect(() => {
    if (
      userdataId !== undefined &&
      userdataId !== null &&
      addEditUser === true
    ) {
      getUserByID();
    }
  }, []);

  const statusOption = [
    { name: "Active", status: true },
    { name: "InActive", status: false },
  ];

  const gateRole = [{ name: "Entry" }, { name: "Exit" }, { name: "Dual" }];

  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  console.log("storedLoginRes", storedLoginRes);
  const userTypeIs = storedLoginRes?.role;
  const userSite = storedLoginRes?.site;
  const loggedUserRole = storedLoginRes?.role?.role;
  console.log("userTypeIs", userTypeIs);
  useEffect(() => {
    formik.setFieldValue("site", userSite);
    setSitevalue(userSite);
  }, [userSite]);

  useEffect(() => {
    const foundSite = siteList?.find((item) => item?._id === userSite);
    setSitevalue(foundSite);
  }, [userSite, siteList]);

  const getRoleOption = async () => {
    try {
      const response = await axios.get(
        `${appUrl.BASE_URL}role?role=${userTypeIs.role}`
      );
      // const data = await response.json();
      setUserType(response?.data?.data);
      console.log("data", response?.data);
      // setFilteredUserList(data); // Initially, set the filtered list to the entire list
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getBoothBySite();
    getBoothId();
    getSiteList();
    getRoleOption();
  }, []);
  console.log("Site List before Dropdown:", siteList); // Add this log statement

  return (
    <div>
      <h5>{addEditUser ? "Edit User" : "Add User"}</h5>
      <div className="brdr__top">
        <form onSubmit={formik.handleSubmit}>
          <div className="card">
            <div className="p-fluid formgrid grid">
              <div className="field col-12 md:col-6 my-pass">
                <label style={{ fontWeight: "bold" }}>Role</label>
                <span
                  className={"Label__Required text-color-red-600"}
                  style={{ color: "red" }}
                >
                  *
                </span>
                <Dropdown
                  id="role"
                  name="role"
                  value={formik.values.role}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("role") },
                    "TextArea__Round"
                  )}
                  options={userType}
                  optionValue="role"
                  optionLabel="title"
                  filter

                  // showClear
                  // filterBy="role"
                ></Dropdown>
                {getFormErrorMessage("role")}
              </div>

              <div className="field col-12 md:col-6">
                <label htmlFor="firstName" style={{ fontWeight: "bold" }}>
                  {" "}
                  First Name{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="firstName"
                  name="firstName"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("firstName") },
                    "TextArea__Round"
                  )}
                  type="text"
                ></InputText>
                {getFormErrorMessage("firstName")}
              </div>

              <div className="field col-12 md:col-6">
                <label htmlFor="lastName" style={{ fontWeight: "bold" }}>
                  {" "}
                  Last Name{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="lastName"
                  name="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("lastName") },
                    "TextArea__Round"
                  )}
                  type="text"
                ></InputText>
                {getFormErrorMessage("lastName")}
              </div>
              {formik.values.role == "site_admin" && !addEditUser && (
                <div className="field col-12 md:col-6">
                  <label htmlFor="lastName" style={{ fontWeight: "bold" }}>
                    {" "}
                    Site{" "}
                  </label>
                  <span className="Label__Required" style={{ color: "red" }}>
                    *
                  </span>
                  <Dropdown
                    id="site"
                    name="site"
                    value={formik.values.site}
                    onChange={formik.handleChange}
                    className={classNames(
                      { "p-invalid": isFormFieldValid("site") },
                      "TextArea__Round"
                    )}
                    options={siteList}
                    optionLabel="site"
                    optionValue="_id"
                    placeholder="--Select--"
                    filter
                    disabled={siteValue?._id === formik.values.site}
                  />
                  {getFormErrorMessage("site")}
                </div>
              )}

              {(loading == false && loggedUserRole == "site_admin" || loggedUserRole == "admin") && (formik.values.role !== "site_admin" && formik.values.role !== "admin") &&  (
                <div className="field col-12 md:col-6">
                  <label htmlFor="boothId" style={{ fontWeight: "bold" }}>
                    {" "}
                    Booth{" "}
                  </label>
                  <span className="Label__Required" style={{ color: "red" }}>
                    *
                  </span>
                  <Dropdown
                    id="boothId"
                    name="boothId"
                    value={formik.values.boothId}
                    onChange={formik.handleChange}
                    className={classNames(
                      { "p-invalid": isFormFieldValid("boothId") },
                      "TextArea__Round"
                    )}
                    options={siteBooths}
                    optionLabel="name"
                    optionValue="_id"
                    placeholder="--Select--"
                    filter
                    // disabled = {siteValue?._id === formik.values.boothId}
                  />
                  {getFormErrorMessage("boothId")}
                </div>
              )}

              <div className="field col-12 md:col-6">
                <label htmlFor="cnic" style={{ fontWeight: "bold" }}>
                  {" "}
                  CNIC{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputMask
                  mask="99999-9999999-9"
                  style={{ textTransform: "uppercase" }}
                  id="cnic"
                  name="cnic"
                  value={formik.values.cnic}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("cnic") },
                    "TextArea__Round"
                  )}
                  type="text"
                ></InputMask>
                {getFormErrorMessage("cnic")}
              </div>

              <div className="field col-12 md:col-6">
                <label htmlFor="phone" style={{ fontWeight: "bold" }}>
                  Contact Number
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                {/* <input
                                    type="text"
                                    value={`+92${userInput}`}
                                    onChange={(e) => {
                                        const newValue = e.target.value.slice(3);
                                        if (/^\d*$/.test(newValue)) {
                                            setTimeout(() => {
                                                setUserInput(newValue);
                                                formik.setFieldValue("phone", `+92${newValue}`);
                                            }, 0);
                                        }
                                    }}
                                    className={classNames({ "p-invalid": isFormFieldValid("status") }, "p-inputtext p-component TextArea__Round")}
                                    id="phone"
                                    name="phone"
                                    maxLength={13}

                                /> */}
                <InputMask
                  mask="99999999999"
                  style={{ textTransform: "uppercase" }}
                  id="phone"
                  name="phone"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("phone") },
                    "TextArea__Round"
                  )}
                  type="text"
                ></InputMask>
                {getFormErrorMessage("phone")}
              </div>

              <div className={addEditUser ? "dNone" : "field col-12 md:col-6"}>
                <label htmlFor="email" style={{ fontWeight: "bold" }}>
                  Email
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="email"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  type="email"
                  className={classNames(
                    { "p-invalid": isFormFieldValid("email") },
                    "TextArea__Round"
                  )}
                  autoComplete="off"
                ></InputText>
                {getFormErrorMessage("email")}
              </div>

              <div
                className={
                  addEditUser ? "dNone" : "field col-12 md:col-6 my-pass"
                }
              >
                <label htmlFor="password" style={{ fontWeight: "bold" }}>
                  {" "}
                  Password{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  style={{ marginTop: "0px !important" }}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  // toggleMask
                  name="password"
                  className={classNames({
                    "p-invalid": isFormFieldValid("password"),
                  })}
                  autoComplete="off"
                />
                {getFormErrorMessage("password")}
              </div>

              {formik.values.editMode && (
                <div className="field col-12 md:col-6">
                  <label style={{ fontWeight: "bold" }}>Status</label>
                  <span className="Label__Required" style={{ color: "red" }}>
                    *
                  </span>
                  <Dropdown
                    id="status"
                    name="status"
                    value={formik.values.status}
                    onChange={formik.handleChange}
                    className={classNames(
                      { "p-invalid": isFormFieldValid("status") },
                      "TextArea__Round"
                    )}
                    options={statusOption}
                    optionLabel="name"
                    optionValue="status"
                    placeholder="--Select--"
                  ></Dropdown>
                  {getFormErrorMessage("status")}
                </div>
              )}

<div className="col-12 text-center mt-6 flex justify-content-end">
                <Button
                  label="Cancel"
                  className="Cancel__button mr-3"
                  type="button"
                  onClick={onHide}
                  disabled={loading}
                />
                <Button
                  type="submit"
                  className="Save__Button"
                  label={addEditUser ? "Update" : "Save"}
                  disabled={loading}
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default AddEditUser;
